import { AbstractControl, ValidationErrors } from '@angular/forms';

export function normalizePhoneNumber(value: string): string {
  const input = (value || '').trim();
  if (!input || !/^\+?[\d\s().-]+$/.test(input)) {
    return input;
  }

  let number = input.replace(/[\s().-]/g, '');
  if (number.startsWith('00')) {
    number = '+' + number.slice(2);
  } else if (/^0[1-9]\d{8}$/.test(number)) {
    number = '+41' + number.slice(1);
  } else if (/^41[1-9]\d{8}$/.test(number)) {
    number = '+' + number;
  }

  if (/^\+41[1-9]\d{8}$/.test(number)) {
    return number.replace(/^(\+41)(\d{2})(\d{3})(\d{2})(\d{2})$/, '$1 $2 $3 $4 $5');
  }

  // Keep invalid input intact so the user can correct it without losing digits.
  return /^\+[1-9]\d{6,14}$/.test(number) ? number : input;
}

export function isValidPhoneNumber(value: string): boolean {
  const number = normalizePhoneNumber(value).replace(/ /g, '');
  if (!number) {
    return true;
  }
  return number.startsWith('+41') ? /^\+41[1-9]\d{8}$/.test(number) : /^\+[1-9]\d{6,14}$/.test(number);
}

export function phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  return isValidPhoneNumber(control.value) ? null : {phoneNumber: true};
}
